import { render, staticRenderFns } from "./ContactChinaPostalAirlines.vue?vue&type=template&id=2e72fa26&scoped=true&"
import script from "./ContactChinaPostalAirlines.vue?vue&type=script&lang=js&"
export * from "./ContactChinaPostalAirlines.vue?vue&type=script&lang=js&"
import style0 from "./ContactChinaPostalAirlines.vue?vue&type=style&index=0&id=2e72fa26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72fa26",
  null
  
)

export default component.exports